import axios from "axios";
import { GET_PATIENT_MASTER_URL } from "api/resources/configs/URL";
import { parseResponse } from "api/resources/handlers/parseResponse/parseResponse";
import { getRequestOptions } from "api/resources/configs/requests";
import { GetPatientMasterProfileResponsePayload } from "./getPatientMasterProfile.fromApi.types";
import { formatGetPatientMasterProfileErrorMessage } from "api/resources/messages/ErrorMessage";

export const PM_ERROR_422 = "PAT0001"; // Backend  will include "PAT0001" in error message when status 422 is detected for get patient master and mychartUserID is not found
export const PM_ERROR_400 = "PAT0002"; // Backend will include "PAT0002" in error message when status 400 is detected for get patient master when records contain blank fields
export const PM_ERROR_404 = "PAT0003"; // Backend will include "PAT0003" in error message when status 404 is detected for getPatientProfile

export interface GetPatientMasterProfileRequestParams {
  MyInfoName: string | null;
  MyInfoDoB: string | null;
  MyInfoSex: string | null;
  UserId: string | null | undefined;
  CodeVerifier: string | null;
  CallGetInfo: boolean;
}

/**
 * The function `getPatientMasterProfile` retrieves a patient's master profile using provided
 * information and returns a response payload.
 * @param  - The `getPatientMasterProfile` function is an asynchronous function that takes in an object
 * with the following parameters:
 * @returns The function `getPatientMasterProfile` is returning a `Promise` that resolves to a
 * `GetPatientMasterProfileResponsePayload`.
 */
export const getPatientMasterProfile = async (
  params: GetPatientMasterProfileRequestParams,
): Promise<GetPatientMasterProfileResponsePayload> => {
  try {
    const response = await axios.post<GetPatientMasterProfileResponsePayload>(
      GET_PATIENT_MASTER_URL(),
      params,
      getRequestOptions(),
    );
    return parseResponse(response, GET_PATIENT_MASTER_URL(), true);
  } catch (error) {
    const msg = formatGetPatientMasterProfileErrorMessage(
      GET_PATIENT_MASTER_URL(),
    );
    console.error(msg);
    throw error;
  }
};
